import { Button, Container, Stack, Typography } from '@mui/material';

import { tApp, tCommon, useI18n } from '@frontend/locales';
import { routes } from '@frontend/utils';

const i18nFallback = {
  unexpectedError: 'An unexpected error occurred…',
  unexpectedErrorDescription:
    'This may be due to a poor network connection. Check your connection or try again later. If the issue persists, please contact support.',
  goBack: 'Go back',
};

export const ErrorView = () => {
  useI18n();

  return (
    <Container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        py: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        maxWidth={430}
      >
        <Stack direction="column">
          <Typography variant="h5" textAlign="center">
            {tApp.errorPages.unexpectedError() || i18nFallback.unexpectedError}
          </Typography>

          <Typography variant="body1" maxWidth={376} textAlign="center">
            {tApp.errorPages.unexpectedErrorDescription() ||
              i18nFallback.unexpectedErrorDescription}
          </Typography>
        </Stack>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => {
            // By changing pathname here instead of using react-router navigation
            // lets the application reset which can help in clearing up bad state
            window.location.pathname = routes.landing;
          }}
        >
          {tCommon.actions.goBack() || i18nFallback.goBack}
        </Button>
      </Stack>
    </Container>
  );
};
